export default __webpack_public_path__ + "static/media/banh-tom-1.3b0fe9b0.jpg";